<script>
import { mapActions, mapState } from "vuex";
import compUmatDetail from "@/components/umatDetail/umat";
import compBaptisDetail from "@/components/umatDetail/baptis";
import compKomuniDetail from "@/components/umatDetail/komuni";
import compKrismaDetail from "@/components/umatDetail/krisma";
import compPerkawinanDetail from "@/components/umatDetail/perkawinan";
import compKematianDetail from "@/components/umatDetail/kematian";
import compRingkasDetail from "@/components/umatDetail/ringkas";
import compKeluargaKatolikDetail from "@/components/umatDetail/keluargaKatolik";

export default {
	name: "umatDetail",
	components: {
		compUmatDetail,
		compBaptisDetail,
		compKomuniDetail,
		compKrismaDetail,
		compPerkawinanDetail,
		compKematianDetail,
		compRingkasDetail,
		compKeluargaKatolikDetail,
	},
	data() {
		return {};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			auth: (state) => state.auth.user,
			umatItem: (state) => state.umat.item,
			keluargaKatolikItem: (state) => state.keluargaKatolik.item,
		}),
	},
	created() {
		if (typeof this.$route.params.id !== "undefined") {
			this.loadData();
		}
	},
	mounted() {},
	watch: {
		isLoading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},
	methods: {
		...mapActions({
			getItemUmat: "umat/getItem",
			setItemUmat: "umat/setItem",
			setItemBabtis: "umatBaptis/setItem",
			setItemKomuni: "umatKomuni/setItem",
			setItemKrisma: "umatKrisma/setItem",
			setItemPerkawinan: "umatPerkawinan/setItem",
			setItemKematian: "umatKematian/setItem",
			setItemkeluargaKatolik: "keluargaKatolik/setItem",
		}),
		loadData() {
			this.getItemUmat(this.$route.params.id).then(
				(response) => {
					this.setItemUmat(response.data.umat);
					this.setItemBabtis(response.data.baptis);
					this.setItemKomuni(response.data.komuni);
					this.setItemKrisma(response.data.krisma);
					this.setItemPerkawinan(response.data.perkawinan);
					this.setItemkeluargaKatolik(response.data.kk);
					this.setItemKematian(response.data.kematian);
				},
				() => {
					this.$router.push("/umat");
				}
			);
		},
		refreshData() {
			this.loadData();
		},
		onBack() {
			this.$router.push("/umat");
		},
		setEdit() {
			this.$router.push("/umat/edit/" + this.umatItem.uid);
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="Umat" title="Umat Detail" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div>
						<b-card no-body>
							<div class="card-header">
								<div class="row">
									<div class="col-sm-6 create-project-btn"></div>
									<div class="col-sm-6 create-project-btn">
										<div class="text-right">
											<b-button-group class="btn-group-pill">
												<b-button
													variant="primary"
													size="sm"
													@click="onBack()"
													v-b-tooltip.hover
													title="Kembali"
													><i class="fa fa-arrow-left"></i> &nbsp;
													&nbsp;Kembali</b-button
												>
												<b-button
													v-show="this.auth.group_id != '3'"
													variant="primary"
													size="sm"
													@click="setEdit()"
													v-b-tooltip.hover
													title="Edit"
													><i class="fa fa-edit"></i
												></b-button>
												<b-button
													variant="primary"
													size="sm"
													@click="refreshData()"
													v-b-tooltip.hover
													title="Refresh"
												>
													<div
														v-show="isLoading"
														class="
															spinner-border spinner-border-sm
															text-light
														"
														role="status"
														aria-hidden="true"
													></div>
													<i
														class="fa fa-refresh"
														v-show="!isLoading"
													></i
												></b-button>
											</b-button-group>
										</div>
									</div>
								</div>
							</div>
							<b-tabs card content-class="mt-3" class="search-list">
								<b-tab title="Ringkas" active>
									<compRingkasDetail />
								</b-tab>
								<b-tab title="Lengkap">
									<compUmatDetail />
									<hr />
									<div class="row user-cards">
										<div class="col-md-6 col-lg-6 col-xl-6">
											<div class="card custom-card">
												<div class="card-header">
													<img
														class="img-fluid img-card-header"
														src="@/assets/images/umat/baptisan.jpg"
														alt=""
													/>
												</div>
												<div class="card-profile">
													<img
														class="rounded-circle shadow"
														src="@/assets/images/umat/baptis-logo.png"
														alt=""
													/>
												</div>
												<div class="text-center profile-details">
													<h4>Baptis</h4>
													<!-- <h6>Manager</h6> -->
												</div>
												<div class="card-footer row">
													<div class="col-12 col-sm-12">
														<compBaptisDetail />
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-6 col-lg-6 col-xl-6">
											<div class="card custom-card">
												<div class="card-header">
													<img
														class="img-fluid img-card-header"
														src="@/assets/images/umat/komuni-pertama.jpg"
														alt=""
													/>
												</div>
												<div class="card-profile">
													<img
														class="rounded-circle shadow"
														src="@/assets/images/umat/komuni.png"
														alt=""
													/>
												</div>
												<div class="text-center profile-details">
													<h4>Komuni I</h4>
												</div>
												<div class="card-footer row">
													<div class="col-12 col-sm-12">
														<compKomuniDetail />
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-6 col-lg-6 col-xl-6">
											<div class="card custom-card">
												<div class="card-header">
													<img
														class="img-fluid img-card-header"
														src="@/assets/images/umat/krisma-header.jpg"
														alt=""
													/>
												</div>
												<div class="card-profile">
													<img
														class="rounded-circle shadow"
														src="@/assets/images/umat/krisma.jpg"
														alt=""
													/>
												</div>
												<div class="text-center profile-details">
													<h4>Krisma</h4>
													<!-- <h6>Manager</h6> -->
												</div>
												<div class="card-footer row">
													<div class="col-12 col-sm-12">
														<compKrismaDetail />
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-6 col-lg-6 col-xl-6">
											<div class="card custom-card">
												<div class="card-header">
													<img
														class="img-fluid img-card-header"
														src="@/assets/images/umat/perkawinan.jpg"
														alt=""
													/>
												</div>
												<div class="card-profile">
													<img
														class="rounded-circle shadow"
														src="@/assets/images/umat/perkawinan.png"
														alt=""
													/>
												</div>
												<div class="text-center profile-details">
													<h4>Perkawinan</h4>
													<!-- <h6>Manager</h6> -->
												</div>
												<div class="card-footer row">
													<div class="col-12 col-sm-12">
														<compPerkawinanDetail />
													</div>
												</div>
											</div>
										</div>

										<div class="col-md-6 col-lg-6 col-xl-6">
											<div class="card custom-card">
												<div class="card-header">
													<img
														class="img-fluid img-card-header"
														src="@/assets/images/umat/kematian-header.jpg"
														alt=""
													/>
												</div>
												<div class="card-profile">
													<img
														class="rounded-circle shadow"
														src="@/assets/images/umat/kematian.jpg"
														alt=""
													/>
												</div>
												<div class="text-center profile-details">
													<h4>Kematian</h4>
													<!-- <h6>Manager</h6> -->
												</div>
												<div class="card-footer row">
													<div class="col-12 col-sm-12">
														<compKematianDetail />
													</div>
												</div>
											</div>
										</div>
									</div>
								</b-tab>
								<b-tab title="Keluarga Katolik">
									<div v-if="keluargaKatolikItem.id">
										<compKeluargaKatolikDetail />
									</div>
									<div v-else>
										<p>Tidak ada data</p>
									</div>
								</b-tab>
							</b-tabs>
						</b-card>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
::v-deep .img-card-header {
	max-height: 200px;
	object-fit: cover;
	width: max-content;
}
::v-deep .profile-details {
	padding: 20px 0 0 0;
}
</style>